import type { ProductLogoSmallProps } from "../types";

export function ProductLogoSmallFleet({
  size = 20,
  color = "#25506B",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M270.841 101.145C282.118 101.43 291.171 110.661 291.171 122.006V226.349C291.171 237.694 282.118 246.925 270.841 247.21L270.303 247.217H103.355C92.0095 247.217 82.7787 238.164 82.4932 226.887L82.4864 226.349V122.006C82.4864 110.481 91.8295 101.138 103.355 101.138H270.303L270.841 101.145ZM103.355 226.349H270.303V122.006H103.355V226.349Z"
        fill={color}
      />
      <path
        d="M155.526 90.7036C155.526 79.1782 164.869 69.8351 176.395 69.8351H197.263C208.788 69.8351 218.131 79.1782 218.131 90.7036V111.572H155.526V90.7036Z"
        fill={color}
      />
      <path
        d="M178.764 165.894C184.048 164.485 189.61 164.485 194.895 165.894L320.822 199.474C332.837 202.678 339.402 215.613 334.895 227.202L294.179 331.9C290.945 331.104 287.601 330.691 284.215 330.691C273.471 330.691 263.155 334.834 255.401 342.233L254.659 342.959C248.732 348.903 242.02 351.56 235.522 351.56C229.024 351.56 222.311 348.903 216.385 342.959C208.554 335.105 197.919 330.691 186.829 330.691C176.085 330.691 165.769 334.834 158.015 342.233L157.273 342.959C151.346 348.903 144.634 351.56 138.136 351.56C131.638 351.56 124.925 348.903 118.999 342.959C111.168 335.105 100.533 330.691 89.4426 330.691C86.0563 330.691 82.7125 331.103 79.478 331.898L38.7625 227.202C34.2557 215.613 40.8205 202.678 52.8353 199.474L178.764 165.894Z"
        fill={color}
      />
      <path
        d="M186.829 361.994C189.601 361.994 192.26 363.097 194.218 365.061C205.396 376.271 219.865 382.862 235.522 382.862C249.716 382.862 262.935 377.446 273.609 368.08H280.737V389.021C267.79 398.262 252.286 403.731 235.522 403.731C217.229 403.731 200.436 397.22 186.829 386.401C173.221 397.22 156.429 403.731 138.136 403.731C119.842 403.731 103.05 397.22 89.4425 386.401C75.8352 397.22 59.0427 403.731 40.7494 403.731V382.862C56.4065 382.862 70.8757 376.271 82.0533 365.061C84.011 363.097 86.6699 361.994 89.4425 361.994C92.2152 361.994 94.8741 363.097 96.8317 365.061C108.009 376.271 122.479 382.862 138.136 382.862C153.793 382.862 168.262 376.271 179.44 365.061C181.397 363.097 184.056 361.994 186.829 361.994Z"
        fill={color}
      />
      <path
        d="M312.04 351.56H332.908V403.731C332.908 409.493 328.237 414.165 322.474 414.165C316.711 414.165 312.04 409.493 312.04 403.731V351.56Z"
        fill={color}
      />
      <path
        d="M426.816 351.56H447.685V403.731C447.685 409.493 443.013 414.165 437.251 414.165C431.488 414.165 426.816 409.493 426.816 403.731V351.56Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M412.619 288.954C421.186 288.954 428.883 294.191 432.029 302.16L446.227 338.129C447.19 340.568 447.685 343.168 447.685 345.79V375.211C447.685 386.736 438.342 396.079 426.816 396.079H332.908C321.383 396.079 312.04 386.736 312.04 375.211V345.79C312.04 343.168 312.535 340.568 313.498 338.129L327.695 302.16C330.841 294.191 338.538 288.954 347.106 288.954H412.619ZM343.342 304.605L332.908 330.691H426.816L416.382 304.605H343.342Z"
        fill={color}
      />
      <path
        d="M51.1837 393.297C51.1837 399.059 46.5121 403.731 40.7494 403.731C34.9867 403.731 30.3152 399.059 30.3152 393.297C30.3152 387.534 34.9867 382.862 40.7494 382.862C46.5121 382.862 51.1837 387.534 51.1837 393.297Z"
        fill={color}
      />
      <path
        d="M291.171 378.515C291.171 384.277 286.5 388.949 280.737 388.949C274.974 388.949 270.303 384.277 270.303 378.515C270.303 372.752 274.974 368.08 280.737 368.08C286.5 368.08 291.171 372.752 291.171 378.515Z"
        fill={color}
      />
    </svg>
  );
}
